import { StyledNavListItem } from "../style";

const NavListItem = ({ selected, handleClick, title, image }) => {
  return (
    <StyledNavListItem selected={selected}>
      <button onClick={handleClick}>
        {image}
        <p>{title}</p>
      </button>
    </StyledNavListItem>
  );
};

export default NavListItem;
